import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useRouteMatch } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { featureSelector } from 'reducers/app.reducer';
import StoreFooter from './StoreFooter';

const SHARED_FOOTER_SCRIPT_ID = 'shared-footer-script';

// MAX serves the bundle itself (same origin as this app), and the component
// is fully self-contained: it fetches its own data (legal links, colors,
// logo...) from MAX's API. No props to wire up.
const loadSharedFooterScript = (lang: string) => {
  if (document.getElementById(SHARED_FOOTER_SCRIPT_ID)) {
    return;
  }

  const script = document.createElement('script');
  script.id = SHARED_FOOTER_SCRIPT_ID;
  // Set before src: OneTrust's auto-blocker hooks the src setter.
  script.setAttribute('data-ot-ignore', '');
  script.src = `${process.env.REACT_APP_HOST}/shared-components-library/standalone-footer.js`;
  script.setAttribute('data-lang', lang);
  document.body.appendChild(script);
};

export const Footer: React.FC = () => {
  const isHidden = !!useRouteMatch({
    path: '/auth',
    strict: true,
    sensitive: true,
  });
  const storeFeature = useSelector(featureSelector('use_store'));
  const canAccessStore = storeFeature?.data?.enabled;
  const {
    i18n: { language },
  } = useTranslation();

  useEffect(() => {
    loadSharedFooterScript(language || 'fr');
  }, [language]);

  return (
    <div style={isHidden ? { display: 'none' } : undefined}>
      {canAccessStore && <StoreFooter />}
      <div id="custom-footer" />
    </div>
  );
};

export default Footer;
